import Vue                  from 'vue'
import Vuex                 from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import floatingWindow   from '@/components/floatingWindow/store'
import canvas           from '@/components/canvas/store'
import object           from '@/components/object/store'
import imageBoard       from '@/components/image/store'
import room            from '@/components/room/store'
import video            from '@/components/video/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    canvas,
    object,
    floatingWindow,
    imageBoard,
    room,
    video
  },
  plugins: [
    createPersistedState({
      paths: [
        'floatingWindow',
        'canvas',
        'imageBoard'
      ]
    })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js